import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = {
  key: 0,
  class: "icon-tubiao-40 iconfont"
}
const _hoisted_6 = { class: "underlineForm" }
const _hoisted_7 = { style: {"display":"none"} }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { class: "underlineForm" }
const _hoisted_10 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_RukuFormComponent = _resolveComponent("RukuFormComponent")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCommand('batchCreate')))
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" 批量创建 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_BATCH_ADD` }]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.list,
          border: "",
          "row-key": "id",
          style: {"width":"40%"},
          lazy: true,
          load: _ctx.handleLoadLazy,
          "highlight-current-row": true,
          "tree-props": { children: 'children', hasChildren: 'hasChildren' },
          onSelectionChange: _ctx.handleSelectionChange,
          onRowClick: _ctx.handlePositonTableClick,
          onHeaderDragend: _ctx.handleHeaderDragend
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnData, (column, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: column.fieldKey + index,
                prop: JSON.stringify(column),
                label: column.fieldName,
                "min-width": column.width || 100,
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({ row }) => [
                  (row.deliveryConfirmed)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : _createCommentVNode("", true),
                  _cache[21] || (_cache[21] = _createTextVNode()),
                  _createElementVNode("span", null, _toDisplayString(row[column.fieldKey]), 1)
                ]),
                _: 2
              }, 1032, ["prop", "label", "min-width"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('table.actions'),
              align: "center",
              width: "200",
              "class-name": "fixed-width"
            }, {
              default: _withCtx(({ row }) => [
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  href: "javascript:void(0);",
                  class: "mr-10",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleCommand('addRow', row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  href: "javascript:void(0);",
                  class: "mr-10",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleCommand('edit', row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
                ]),
                _createVNode(_component_el_link, {
                  href: "javascript:void(0);",
                  class: "mr-10",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleCommand('rukuError', row))
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode(" 异常入库 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  href: "javascript:void(0);",
                  type: "danger",
                  onClick: ($event: any) => (_ctx.handleCommand('delete', row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.delete")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_permission, { pkey: `${_ctx.permissionName}_DELETE` }]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "load", "onSelectionChange", "onRowClick", "onHeaderDragend"])), [
          [_directive_loading, _ctx.listLoading]
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.materialData,
          style: {"flex":"1"},
          border: "",
          "highlight-current-row": true,
          onHeaderDragend: _ctx.handleMaterialHeaderDragend
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialCloumn, (column, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: column.fieldKey + index,
                prop: JSON.stringify(column),
                label: column.fieldName,
                "min-width": column.width || 100,
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row[column.fieldKey]), 1)
                ]),
                _: 2
              }, 1032, ["prop", "label", "min-width"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleChangePosition(scope.row)),
                  class: "mr-10"
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("调换", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleMaterialTableClick(scope.row))
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("变更明细", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                (scope.row.amount)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.handleChuku(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createTextVNode("直接出库", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onHeaderDragend"])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.exchangeRukuVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: _ctx.pathApi,
          "onUpdate:visibel": _cache[3] || (_cache[3] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api"]))
      : _createCommentVNode("", true),
    (_ctx.batchCreateVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.batchCreateVisible,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.batchCreateVisible) = $event)),
          "close-on-click-modal": false,
          title: "批量创建",
          width: "50%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_el_button, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.batchCreateVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleBatchCreateSubmit
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "local-batch-rule" }, [
              _createTextVNode("批量生成规则：[名称]= [前缀] + [号码]；"),
              _createElementVNode("br"),
              _createTextVNode("例如：当prefix=No，startNum=1，endNum=100，numMinSize=3；"),
              _createElementVNode("br"),
              _createTextVNode("将生成100个位置信息[No001,No002,No003...]。")
            ], -1)),
            _createVNode(_component_el_form, {
              ref: "dataForm",
              model: _ctx.formData,
              rules: _ctx.rules,
              "label-position": "top",
              "label-width": "100px",
              class: "mb-20"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: "上级位置",
                    prop: "superId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_cascader, {
                        filterable: true,
                        modelValue: _ctx.formData.superId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.superId) = $event)),
                        class: "filter-item",
                        props: _ctx.cascaderLoad,
                        clearable: true,
                        placeholder: "输入关键字搜索"
                      }, {
                        default: _withCtx(({ node, data }) => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(node.isLeaf), 1),
                          _createElementVNode("span", null, _toDisplayString(data.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "props"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "前缀",
                    prop: "prefix"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.prefix,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.prefix) = $event)),
                        class: "filter-item",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "开始号码",
                    prop: "startNum"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.startNum,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.startNum) = $event)),
                        class: "filter-item",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "结束号码",
                    prop: "endNum"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.endNum,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.endNum) = $event)),
                        class: "filter-item",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "号码最小位数",
                    prop: "numMinSize"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.numMinSize,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.numMinSize) = $event)),
                        class: "filter-item",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.historyVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.historyVisible,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.historyVisible) = $event)),
          "close-on-click-modal": false,
          title: "变更明细",
          width: "700px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              border: "",
              data: _ctx.inOutHistoryData,
              "highlight-current-row": true,
              onHeaderDragend: _ctx.handleHistoryHeaderDragend
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyCloumn, (column, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    key: column.fieldKey + index,
                    prop: JSON.stringify(column),
                    label: column.fieldName,
                    "min-width": column.width || 100,
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", null, _toDisplayString(row[column.fieldKey]), 1)
                    ]),
                    _: 2
                  }, 1032, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "onHeaderDragend"]),
            _withDirectives(_createVNode(_component_el_pagination, {
              class: "mt-20",
              total: _ctx.inOutHistoryPageVo.total,
              currentPage: _ctx.inOutHistoryPageVo.page,
              "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inOutHistoryPageVo.page) = $event)),
              "page-size": _ctx.inOutHistoryPageVo.size,
              "page-sizes": _ctx.pageSizes,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange,
              layout: "total, sizes, prev, pager, next"
            }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
              [_vShow, _ctx.inOutHistoryPageVo.total > 0]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.exchangeRukuVisible)
      ? (_openBlock(), _createBlock(_component_RukuFormComponent, {
          key: 3,
          api: 'purchase',
          from: "local",
          locationId: _ctx.activeLocalRow.id,
          purchaseType: _ctx.purchaseType,
          materialData: _ctx.activeMaterialRow,
          "onUpdate:visibel": _cache[14] || (_cache[14] = () => _ctx.exchangeRukuVisible = false),
          onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleExchangeRukuSubmit(_ctx.formData)))
        }, null, 8, ["locationId", "purchaseType", "materialData"]))
      : _createCommentVNode("", true),
    (_ctx.chukuVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          modelValue: _ctx.chukuVisible,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.chukuVisible) = $event)),
          title: "出库确认",
          width: "500px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_el_button, {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.chukuVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleSubmitChuku
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "dataForm",
              model: _ctx.chukuFormData,
              rules: _ctx.chukuRules,
              "label-position": "top",
              "label-width": "100px",
              class: "mb-20"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_form_item, {
                    label: "数量",
                    prop: "paymentMark",
                    class: "fullWidth"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.chukuFormData.num,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.chukuFormData.num) = $event)),
                        placeholder: " ",
                        type: "number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}